import $api from "@/utils/request";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { SelectLang as UmiSelectLang } from "@umijs/max";
import useMessage from "antd/lib/message/useMessage";
import type { AxiosResponse } from "axios";
import { useEffect } from "react";

export type SiderTheme = "light" | "dark";

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question: React.FC = () => {
  const [messageApi] = useMessage();

  useEffect(() => {
    const interceptor = (response: AxiosResponse) => {
      if (
        (response.data && response?.data?.success === false) ||
        response.status.toString().startsWith("4") ||
        response.status.toString().startsWith("5")
      ) {
        messageApi.error(JSON.stringify(response.data));
      }
      return response;
    };

    const id = $api.interceptors.response.use(interceptor);

    return () => {
      $api.interceptors.response.eject(id);
    };
  }, []);
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: "inline-flex",
        padding: "4px",
        fontSize: "18px",
        color: "inherit",
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
